export default __webpack_public_path__ + "static/media/graf-mission.7694e1a3.svg";